import { useGateValue } from '@statsig/react-bindings';

/**
 * Returns whether Application rollup rows (class === 'application') are
 * surfaced in the UI for the current user. When the gate is OFF, the asset
 * table filters Application rows out client-side and the standard asset
 * drawer is the only drawer reachable. When ON, Applications appear in
 * (:Asset) listings and clicking one opens the Application-aware drawer
 * content (rolled-up IPs, ports, web applications).
 *
 * Backend /my returns Applications uniformly today — gating lives here.
 */
export function useApplicationDrawerEnabled(): boolean {
  return useGateValue('application_drawer');
}
